<template>
    <div class="card-data" :class="xl?'xl':md?'md':'lg'">
        <Tooltip
            v-show="tip"
            :tip="tip" />
        <div class="card-title">
            <h5 class="title">{{title}}</h5>
            <small v-if="sub">{{sub}}</small>
            <div style="height: 29px" v-else></div>
        </div>
        <div v-if="!loader">
            <Loader/>
        </div>
        <!-- <div v-else-if="!nodata">
            <EmptyStateChart
            :title="titleEmpty"
            :caption="captionEmpty"
            />
        </div> -->
        
        <div :class="responsive ? 'apexchart' : ''" v-if="loader&&nodata">
            <apexchart type="line" :height="height" :options="chartOptions" :series="data"></apexchart>
        </div>
        
    </div>
</template>

<script>
import Loader from '@/components/Loader'
import Tooltip from '@/components/Tooltip'
import EmptyStateChart from '@/components/EmptyStateChart'
import _ from 'lodash'  

export default {
    name: 'LineGraphCard',
    components: {
        Loader,
        Tooltip,
        EmptyStateChart
    },
    props: {
        title: {
            type: String,
            required: true
        },
        sub: {
            type: String,
            required: false
        },
        tip: {
            type: String,
            required: true,
            default: ''
        },
        data: {
            type: Array,
            required: true
        },
        periodItems: {
            type: Array,
            required: true
        },
        sm: {
            type: Boolean,
            required: false
        },
        labels: {
            default: true,
            type: Boolean
        },
        loader: {
            type: Boolean,
            required: true
        },
        xl: {
            type: Boolean,
            default: false
        },
        md: {
            type: Boolean,
            default: false
        },
        responsive:{
            type: Boolean,
            required: false
        },
        height:{
            type: String,
            default: "250"
        },
        captionEmpty:{
            type: String,
            default: "Puedes consultar la vista de los últimos 7 o 30 días.",
        },
        titleEmpty: {
            type: String,
            default: "Este gráfico no esta disponible para esta vista"
        }
    },
    data: function(){
        return {
            tooltip: false,
        }
    },
    computed: {
        display: function() {
            if(this.$store.getters["auth/getOneDayLineRange"]){
                return false
            }
            return true
        },
        nodata: function(){
            let totaldata = 0
            _.each(this.data,(value,index)=>{
                _.each(value.data,(item)=>{
                    totaldata = totaldata + item 
                })
            }) 
            return totaldata
        },
        chartOptions: function() {
            return {    
                chart: {
                    type: 'line',
                    toolbar: {
                        show: false
                    },
                    zoom: {
                        enabled: false
                    },
                    animations: {
                        enabled: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'straight'
                },
                colors: ["#720acb", "#f1840a"],
                xaxis: {
                    type: 'categories',
                    categories: this.periodItems,
                    labels: {
                        rotate: -45,
                        rotateAlways: true,
                        hideOverlappingLabels: false,
                        maxHeight: 120,
                        formatter: function (value, timestamp) {
                            let monthNames = [
                                "Ene", "Feb", "Mar",
                                "Abr", "May", "Jun", "Jul",
                                "Ago", "Sep", "Oct",
                                "Nov", "Dic"
                            ]
                            if (value && value.includes('-')) {
                                return value.split('-')[0] + "-" + monthNames[value.split('-')[1] - 1]
                            } else if (value) {
                                if (value > 12) {
                                    return (value - 12).toString() + ":00 pm"
                                } else if (value == 12) {
                                    return  value + ":00 pm"
                                } else if (value == "00") {
                                    return "12:00 am"
                                }
                                return value + ":00 am"
                            }
                        }
                    },
                    tooltip: {
                        enabled: false
                    }
                },
                yaxis: {
                    tickAmount: 1,
                    labels: {
                        formatter: function (value) {
                            return (value).toLocaleString('es')
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                    },
                },
                fill: {
                    opacity: 1
                },
                responsive: this.responsive ? [{
                    breakpoint: 420,
                    options:{
                        chart:{
                            height: 100,
                            width: "100%",
                            type: "line",
                            parentHeightOffset: 0,
                        },
                        stroke:{
                            curve: "smooth",
                        },
                        yaxis:{
                            show: false,
                        },
                        xaxis:{
                            labels:{
                                show: false,
                            },
                            axisTicks:{
                                show: true,
                                height: "100%",
                            },
                        },
                        grid:{
                            show: true,
                            padding:{
                                left: 8,
                                right: 8,
                                top: -10,
                                bottom: -10,
                            },
                        },
                        legend:{
                            show: false
                        },
                        tooltip:{
                            enabled: true,
                            fixed: {
                                enabled: true,
                                position: "topLeft",
                                offsetY: -55,
                            }
                        },
                    }
                    }
                ] : []
            }
        }
    }
}
</script>

<style lang="sass">
.invalid-display
    display: block
    max-width: 220px
    max-height: 220px
    margin: 12px auto 
.invalid-display-text
    width: 100%
    margin-bottom: 8px
    display: block
    font-family: Muli
    font-size: 16px
    text-align: center
    color: #302f2f

@include mobile
    .apexchart
        div
            background: $lighter-grey
            border-radius: 8px
            margin-bottom: 8px
            // overflow: hidden
</style>